import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import TableViewOutlinedIcon from "@mui/icons-material/TableViewOutlined";
import { Box, CircularProgress, DialogContent, Paper } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { compose } from "@reduxjs/toolkit";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import RTTable from "../../components/Comman/RT/RTTable";
import TypographyCompo from "../../components/Comman/TypographyCompo";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../components/withRouter";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { offerJson } from "../../DynamicFormsJson/MastersJSON/offer";
import { getOfferHeaderById } from "../../Slice/offer.slice";
import { getActiveProduct } from "../../Slice/product.slice";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import {
	injectAdvanceOutletInvoicingColorVars,
} from "../AdvanceOutletInvoicing/styles/advanceOutletInvoicingColorVars";
import "../AdvanceOutletInvoicing/styles/advanceOutletInvoicing.css";
import "./OfferDetailsOnBillingPreview.css";

const ClassicBootstrapDialog = styled(Dialog)(({ theme }) => ({
	"& .MuiDialogContent-root": {
		padding: theme.spacing(2),
	},
	"& .MuiDialogActions-root": {
		padding: theme.spacing(1),
	},
}));

const EnhancedBootstrapDialog = styled(Dialog)(() => ({}));

const ClassicBootstrapDialogTitle = ({ children, onClose, ...other }) => (
	<DialogTitle sx={{ m: 0, p: 2 }} {...other}>
		{children}
		{onClose ? (
			<IconButton
				aria-label="close"
				onClick={onClose}
				sx={{
					position: "absolute",
					right: 8,
					top: 8,
					color: (theme) => theme.palette.grey[500],
				}}
			>
				<CloseIcon />
			</IconButton>
		) : null}
	</DialogTitle>
);

ClassicBootstrapDialogTitle.propTypes = {
	children: PropTypes.node,
	onClose: PropTypes.func.isRequired,
};

const EnhancedBootstrapDialogTitle = ({ children, onClose, ...other }) => (
	<DialogTitle sx={{ m: 0, p: 0 }} {...other}>
		{children}
		{onClose ? (
			<IconButton
				aria-label="close"
				onClick={onClose}
				sx={{
					position: "absolute",
					right: 8,
					top: 8,
					color: (theme) => theme.palette.grey[500],
				}}
			>
				<CloseIcon />
			</IconButton>
		) : null}
	</DialogTitle>
);

EnhancedBootstrapDialogTitle.propTypes = {
	children: PropTypes.node,
	onClose: PropTypes.func.isRequired,
};

const formatDisplayValue = (value, suffix = "") => {
	if (value === null || value === undefined || value === "") {
		return null;
	}
	return `${value}${suffix}`;
};

const hasDisplayValue = (value) =>
	value !== null && value !== undefined && value !== "";

const buildClassicDataToSet = (data) => [
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "Name",
		value: data.name !== null ? data.name : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "Description",
		value: data.discription !== null ? data.discription : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "From Date",
		value: data.fromDate !== null ? data.fromDate : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "To Date",
		value: data.toDate !== null ? data.toDate : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "Type",
		value: data.type !== null ? data.type : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "From Date (Range)",
		value: data.fromRangeDate !== null ? data.fromRangeDate : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "To Date (Range)",
		value: data.toRangeDate !== null ? data.toRangeDate : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "Offer For",
		value: data.offerFor !== null ? data.offerFor : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "Stock Holder Type",
		value:
			data.stockStakeHolderTypeName === null
				? "-"
				: data.stockStakeHolderTypeName,
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "Level",
		value: data.levelName !== null ? data.levelName : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "Level-Wise Type",
		value: data.levelWiseTypeName !== null ? data.levelWiseTypeName : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "Applicable Amount",
		value: data.applicableAmount !== null ? data.applicableAmount : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "Discount Amount",
		value: data.discountAmount !== null ? data.discountAmount : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "Discount Percentage",
		value:
			data.discountPercentage !== null ? `${data.discountPercentage} %` : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "Product",
		value: data.productName !== null ? data.productName : "",
	},
	{
		xs: 12,
		sm: 6,
		md: 6,
		lg: 6,
		label: "Quantity",
		value: data.qty !== null ? data.qty : "",
	},
];

const buildStatCards = (data) => {
	const cards = [
		{
			key: "discountPercentage",
			label: "Discount %",
			value: formatDisplayValue(data.discountPercentage, " %"),
			highlight: true,
			isDiscount: true,
		},
		{
			key: "discountAmount",
			label: "Discount Amount",
			value: formatDisplayValue(data.discountAmount),
			isDiscount: true,
			highlight: true,
		},
		{
			key: "applicableAmount",
			label: "Applicable Amount",
			value: formatDisplayValue(data.applicableAmount),
			highlight: true,
		},
		{
			key: "qty",
			label: "Quantity",
			value: formatDisplayValue(data.qty),
			highlight: true,
		},
	];

	return cards.filter((card) => hasDisplayValue(card.value));
};

const buildDetailSections = (data) => {
	const sections = [
		{
			id: "validity",
			title: "Validity Period",
			icon: CalendarTodayOutlinedIcon,
			items: [
				{ label: "From Date", value: data.fromDate },
				{ label: "To Date", value: data.toDate },
				{ label: "From Date (Range)", value: data.fromRangeDate },
				{ label: "To Date (Range)", value: data.toRangeDate },
			],
		},
		{
			id: "configuration",
			title: "Offer Configuration",
			icon: SettingsOutlinedIcon,
			items: [
				{ label: "Type", value: data.type },
				{ label: "Offer For", value: data.offerFor },
				{ label: "Stock Holder Type", value: data.stockStakeHolderTypeName },
				{ label: "Level", value: data.levelName },
				{ label: "Level-Wise Type", value: data.levelWiseTypeName },
				{ label: "Product", value: data.productName },
			],
		},
	];

	return sections
		.map((section) => ({
			...section,
			items: section.items.filter((item) => hasDisplayValue(item.value)),
		}))
		.filter((section) => section.items.length > 0);
};

const buildBadges = (data) => {
	const badges = [];

	if (hasDisplayValue(data.type)) {
		badges.push({ label: data.type, tone: "primary" });
	}
	if (hasDisplayValue(data.levelName)) {
		badges.push({ label: data.levelName, tone: "success" });
	}
	if (hasDisplayValue(data.offerFor)) {
		badges.push({ label: data.offerFor, tone: "warning" });
	}

	return badges;
};

const formatSlabBoundValue = (value, valueType) => {
	if (value === null || value === undefined || value === "") {
		return "-";
	}
	if (valueType == 0) {
		return value;
	}
	const numericValue = Number(value);
	return Number.isNaN(numericValue) ? value : numericValue.toFixed(2);
};

const getSlabRangeLabel = (slab) =>
	slab.valueType == 0 ? "Quantity" : "Value";

const getSlabRangeDisplay = (slab) =>
	`${formatSlabBoundValue(slab.minValue, slab.valueType)} - ${formatSlabBoundValue(
		slab.maxValue,
		slab.valueType,
	)}`;

const getSlabPeriodDisplay = (slab) => {
	if (!hasDisplayValue(slab.fromDate) && !hasDisplayValue(slab.toDate)) {
		return null;
	}
	return `${slab.fromDate || "-"}  to  ${slab.toDate || "-"}`;
};

const hasMeaningfulProductNames = (names) =>
	hasDisplayValue(names) && names !== "-";

const resolveSlabProducts = (slab, kind, productCatalog = []) => {
	const isInclusive = kind === "inclusive";
	const products = isInclusive ? slab.inclusiveProducts : slab.exclusiveProducts;
	const productIds = isInclusive
		? slab.inclusiveProductIds
		: slab.exclusiveProductIds;
	const productNames = isInclusive
		? slab.inclusiveProductNames
		: slab.exclusiveProductNames;

	if (Array.isArray(products) && products.length > 0) {
		return products
			.map((product, index) => ({
				id: product.id || product.productId || `${kind}-${index}`,
				name:
					product.productName ||
					product.name ||
					product.entityName ||
					"",
				code: product.code || "",
				categoryName: product.categoryName || "",
			}))
			.filter((product) => hasDisplayValue(product.name));
	}

	if (hasMeaningfulProductNames(productNames)) {
		return productNames
			.split(",")
			.map((name, index) => ({
				id: `${kind}-name-${index}`,
				name: name.trim(),
				code: "",
				categoryName: "",
			}))
			.filter((product) => hasDisplayValue(product.name));
	}

	if (!hasDisplayValue(productIds) || productIds === "") {
		return [];
	}

	const catalog = Array.isArray(productCatalog) ? productCatalog : [];

	return productIds
		.split(",")
		.map((rawId) => rawId.trim())
		.filter(Boolean)
		.map((id) => {
			const match = catalog.find((product) => product.id === id);
			return {
				id,
				name: match?.name || match?.productName || "Unknown product",
				code: match?.code || "",
				categoryName: match?.categoryName || "",
			};
		});
};

const slabHasProductScope = (slab, productCatalog) =>
	resolveSlabProducts(slab, "inclusive", productCatalog).length > 0 ||
	resolveSlabProducts(slab, "exclusive", productCatalog).length > 0 ||
	hasDisplayValue(slab.inclusiveProductIds) ||
	hasDisplayValue(slab.exclusiveProductIds);

const SlabProductScrollPanel = ({
	title,
	variant,
	products,
	emptyLabel,
}) => {
	const [query, setQuery] = React.useState("");
	const normalizedQuery = query.trim().toLowerCase();

	const filteredProducts = normalizedQuery
		? products.filter((product) => {
				const haystack = [product.name, product.code, product.categoryName]
					.filter(Boolean)
					.join(" ")
					.toLowerCase();
				return haystack.includes(normalizedQuery);
			})
		: products;

	const PanelIcon =
		variant === "exclusive" ? RemoveCircleOutlineIcon : CheckCircleOutlineIcon;

	return (
		<div
			className={`offer-details-slab-product-panel offer-details-slab-product-panel--${variant}`}
		>
			<div className="offer-details-slab-product-panel-header">
				<div className="offer-details-slab-product-panel-title">
					<PanelIcon className="offer-details-slab-product-panel-icon" />
					<span>{title}</span>
					<span className="offer-details-slab-product-panel-count">
						{products.length}
					</span>
				</div>
				{products.length > 0 && (
					<div className="offer-details-slab-product-search-wrap">
						<SearchIcon className="offer-details-slab-product-search-icon" />
						<input
							type="text"
							className="offer-details-slab-product-search"
							placeholder="Search products..."
							value={query}
							onChange={(event) => setQuery(event.target.value)}
							aria-label={`Search ${title}`}
						/>
					</div>
				)}
			</div>

			<div className="offer-details-slab-product-scroll">
				{products.length === 0 ? (
					<div className="offer-details-slab-product-empty">{emptyLabel}</div>
				) : filteredProducts.length === 0 ? (
					<div className="offer-details-slab-product-empty">
						No products match your search.
					</div>
				) : (
					<ul className="offer-details-slab-product-list">
						{filteredProducts.map((product, index) => (
							<li
								className="offer-details-slab-product-item"
								key={product.id || `${variant}-${index}`}
							>
								<span className="offer-details-slab-product-index">
									{index + 1}
								</span>
								<div className="offer-details-slab-product-info">
									<TypographyCompo className="offer-details-slab-product-name">
										{product.name}
									</TypographyCompo>
									{(product.code || product.categoryName) && (
										<TypographyCompo className="offer-details-slab-product-meta">
											{[product.code, product.categoryName]
												.filter(Boolean)
												.join(" · ")}
										</TypographyCompo>
									)}
								</div>
							</li>
						))}
					</ul>
				)}
			</div>
		</div>
	);
};

SlabProductScrollPanel.propTypes = {
	title: PropTypes.string.isRequired,
	variant: PropTypes.oneOf(["inclusive", "exclusive"]).isRequired,
	products: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			name: PropTypes.string,
			code: PropTypes.string,
			categoryName: PropTypes.string,
		}),
	).isRequired,
	emptyLabel: PropTypes.string.isRequired,
};

class OfferDetailsOnBillingPreview extends React.Component {
	constructor(props) {
		super(props);
		const { showEnhancedOfferUI = false } = props;

		this.state = {
			DataToSet: [],
			offerDetails: [],
			offerSlabWiseData: [],
			productDetails: [],
			activeProductCatalog: [],
			levelWiseType: "",
			headerData: {},
			openPopUpFlag: showEnhancedOfferUI,
			// isLoading: showEnhancedOfferUI,
		};
		this.columns = [
			{
				title: "Sr.No.",
				name: "index",
				align: "center",
			},
			{
				title: "Product Name",
				name: "productName",
			},
			{
				title: "Quantity",
				name: "qty",
				align: "right",
			},
			{
				title: "Percentage (%)",
				name: "percentage",
				align: "right",
			},
		];
		this.columnsForLevelWise = [
			{
				title: "Sr.No.",
				name: "index",
				align: "center",
			},
			{
				title: "Product Name",
				name: "name",
			},
			{
				title: "Code",
				name: "code",
				align: "center",
			},
			{
				title: "Category",
				name: "categoryName",
				align: "left",
			},
		];
	}

	async componentDidMount() {
		const {
			orderOfferId,
			getOfferHeaderById,
			getActiveProduct,
			showLoador,
			showNotification,
			showEnhancedOfferUI = false,
		} = this.props;

		if (showEnhancedOfferUI) {
			injectAdvanceOutletInvoicingColorVars();
		}

		if (!navigator.onLine) {
			showNotification({ msg: noInternetMsg, severity: "error" });
			this.setState({ isLoading: false });
			return;
		}

		showLoador({ loador: true });

		try {
			const { response, success } = await getActiveProduct();
			if (!success) {
				showNotification({ msg: serverMsg, severity: "error" });
				this.setState({ isLoading: false });
				return;
			}

			const { data, success: offerSuccess } = await getOfferHeaderById({
				offerHeaderId: orderOfferId,
			});

			if (!offerSuccess || !data) {
				showNotification({ msg: serverMsg, severity: "error" });
				this.setState({ isLoading: false });
				return;
			}

			const productIds =
				data.productIds && data.productIds !== ""
					? data.productIds.split(",")
					: [];

			this.setState({
				headerData: data,
				DataToSet: buildClassicDataToSet(data),
				offerDetails:
					Array.isArray(data.offerDetails) && data.offerDetails.length !== 0
						? data.offerDetails
						: [],
				offerSlabWiseData:
					Array.isArray(data.offerSlabWiseData) &&
					data.offerSlabWiseData.length !== 0
						? data.offerSlabWiseData
						: [],
				productDetails: productIds
					.map((productId) =>
						response.filter((product) => productId === product.id),
					)
					.flat(),
				activeProductCatalog: Array.isArray(response) ? response : [],
				levelWiseType: data.levelWiseType,
				openPopUpFlag: true,
				isLoading: false,
			});
		} finally {
			showLoador({ loador: false });
		}
	}

	handleClose = () => {
		const { onClose } = this.props;
		onClose();
	};

	renderDetailSection = (section) => {
		const SectionIcon = section.icon;

		return (
			<div className="offer-details-section" key={section.id}>
				<div className="offer-details-section-header">
					<SectionIcon className="offer-details-section-header-icon" />
					<TypographyCompo className="offer-details-section-title">
						{section.title}
					</TypographyCompo>
				</div>
				<div className="offer-details-section-body">
					{section.items.map((item) => (
						<div className="offer-details-detail-row" key={item.label}>
							<TypographyCompo className="offer-details-detail-label">
								{item.label}
							</TypographyCompo>
							<TypographyCompo className="offer-details-detail-value">
								{item.value}
							</TypographyCompo>
						</div>
					))}
				</div>
			</div>
		);
	};

	renderTableSection = (title, icon, count, columns, tableData) => {
		const TableIcon = icon;

		return (
			<div className="offer-details-table-section">
				<div className="offer-details-table-header">
					<div className="offer-details-table-title">
						<TableIcon fontSize="small" />
						<span>{title}</span>
					</div>
					<span className="offer-details-table-count">{count} item(s)</span>
				</div>
				<div className="offer-details-table-wrapper">
					<RTTable
						columns={columns}
						tableData={tableData}
						isActionColActive={false}
						showPegination={false}
					/>
				</div>
			</div>
		);
	};

	renderSlabCard = (slab) => {
		const { activeProductCatalog } = this.state;
		const periodDisplay = getSlabPeriodDisplay(slab);
		const inclusiveProducts = resolveSlabProducts(
			slab,
			"inclusive",
			activeProductCatalog,
		);
		const exclusiveProducts = resolveSlabProducts(
			slab,
			"exclusive",
			activeProductCatalog,
		);
		const showProductPanels = slabHasProductScope(slab, activeProductCatalog);
		const showPerUnit =
			slab.perUnit !== null &&
			slab.perUnit !== undefined &&
			Number(slab.perUnit) !== 0;

		return (
			<div className="offer-details-slab-card" key={slab.id || slab.index}>
				<div className="offer-details-slab-card-header">
					<span className="offer-details-slab-badge">
						Slab {slab.index}
					</span>
					<span className="offer-details-slab-type">
						{slab.valueTypeName || getSlabRangeLabel(slab)}
					</span>
					{hasDisplayValue(slab.discount) && (
						<span className="offer-details-slab-discount">
							{slab.discount}% Off
						</span>
					)}
				</div>

				<div className="offer-details-slab-metrics">
					<div className="offer-details-slab-metric">
						<TypographyCompo className="offer-details-slab-metric-label">
							{getSlabRangeLabel(slab)} Range
						</TypographyCompo>
						<TypographyCompo className="offer-details-slab-metric-value">
							{getSlabRangeDisplay(slab)}
						</TypographyCompo>
					</div>
					<div className="offer-details-slab-metric">
						<TypographyCompo className="offer-details-slab-metric-label">
							Discount
						</TypographyCompo>
						<TypographyCompo className="offer-details-slab-metric-value offer-details-slab-metric-value--discount">
							{hasDisplayValue(slab.discount) ? `${slab.discount} %` : "-"}
						</TypographyCompo>
					</div>
					{periodDisplay && (
						<div className="offer-details-slab-metric">
							<TypographyCompo className="offer-details-slab-metric-label">
								Period
							</TypographyCompo>
							<TypographyCompo className="offer-details-slab-metric-value">
								{periodDisplay}
							</TypographyCompo>
						</div>
					)}
					{showPerUnit && (
						<div className="offer-details-slab-metric">
							<TypographyCompo className="offer-details-slab-metric-label">
								Per Unit
							</TypographyCompo>
							<TypographyCompo className="offer-details-slab-metric-value">
								{slab.perUnit}
							</TypographyCompo>
						</div>
					)}
				</div>

				{showProductPanels && (
					<div className="offer-details-slab-product-panels">
						<SlabProductScrollPanel
							title="Inclusive Products"
							variant="inclusive"
							products={inclusiveProducts}
							emptyLabel="No inclusive products for this slab."
						/>
						<SlabProductScrollPanel
							title="Exclusive Products"
							variant="exclusive"
							products={exclusiveProducts}
							emptyLabel="No exclusive products for this slab."
						/>
					</div>
				)}
			</div>
		);
	};

	renderSlabWiseSection = () => {
		const { offerSlabWiseData } = this.state;

		if (!offerSlabWiseData.length) {
			return null;
		}

		return (
			<div className="offer-details-slab-section">
				<div className="offer-details-table-header">
					<div className="offer-details-table-title">
						<LayersOutlinedIcon fontSize="small" />
						<span>Slab Wise Offer Details</span>
					</div>
					<span className="offer-details-table-count">
						{offerSlabWiseData.length} slab(s)
					</span>
				</div>
				<div className="offer-details-slab-list">
					{offerSlabWiseData.map(this.renderSlabCard)}
				</div>
			</div>
		);
	};

	renderEnhancedContent = () => {
		const {
			headerData,
			offerDetails,
			offerSlabWiseData,
			productDetails,
			levelWiseType,
			isLoading,
		} = this.state;

		if (isLoading) {
			return (
				<div className="offer-details-loading">
					<CircularProgress size={36} />
					<TypographyCompo>Loading offer details...</TypographyCompo>
				</div>
			);
		}

		if (!Object.keys(headerData).length) {
			return (
				<div className="offer-details-empty">Loading offer details...</div>
			);
		}

		const isSlabWiseOffer =
			Array.isArray(offerSlabWiseData) && offerSlabWiseData.length > 0;
		const statCards = isSlabWiseOffer ? [] : buildStatCards(headerData);
		const detailSections = isSlabWiseOffer ? [] : buildDetailSections(headerData);
		const badges = buildBadges(headerData);
		const showProductTable =
			productDetails.length !== 0 &&
			(levelWiseType == "5" || levelWiseType == "7");

		return (
			<>
				<div className="offer-details-hero">
					<TypographyCompo className="offer-details-hero-name">
						{headerData.name || "Offer"}
					</TypographyCompo>
					{hasDisplayValue(headerData.discription) && (
						<TypographyCompo className="offer-details-hero-description">
							{headerData.discription}
						</TypographyCompo>
					)}
					{badges.length > 0 && (
						<div className="offer-details-badges">
							{badges.map((badge) => (
								<span
									key={badge.label}
									className={`offer-details-badge offer-details-badge--${badge.tone}`}
								>
									{badge.label}
								</span>
							))}
						</div>
					)}
				</div>

				{statCards.length > 0 && (
					<div className="offer-details-stats">
						{statCards.map((card) => (
							<div
								key={card.key}
								className={`offer-details-stat-card${
									card.highlight ? " offer-details-stat-card--highlight" : ""
								}`}
							>
								<TypographyCompo className="offer-details-stat-label">
									{card.label}
								</TypographyCompo>
								<TypographyCompo
									className={`offer-details-stat-value${
										card.isDiscount ? " offer-details-stat-value--discount" : ""
									}`}
								>
									{card.value}
								</TypographyCompo>
							</div>
						))}
					</div>
				)}

				{detailSections.length > 0 && (
					<div className="offer-details-sections">
						{detailSections.map(this.renderDetailSection)}
					</div>
				)}

				{this.renderSlabWiseSection()}

				{showProductTable &&
					this.renderTableSection(
						"Applicable Products",
						Inventory2OutlinedIcon,
						productDetails.length,
						this.columnsForLevelWise,
						productDetails,
					)}

				{offerDetails.length !== 0 &&
					this.renderTableSection(
						"Offer Breakdown",
						TableViewOutlinedIcon,
						offerDetails.length,
						this.columns,
						offerDetails,
					)}
			</>
		);
	};

	renderClassicUI = () => {
		const {
			offerDetails,
			openPopUpFlag,
			levelWiseType,
			DataToSet,
			productDetails,
		} = this.state;

		return (
			<ClassicBootstrapDialog
				onClose={this.handleClose}
				aria-labelledby="customized-dialog-title"
				open={openPopUpFlag}
				fullWidth
				maxWidth="lg"
			>
				<ClassicBootstrapDialogTitle
					id="customized-dialog-title"
					onClose={this.handleClose}
				>
					Offer Details
				</ClassicBootstrapDialogTitle>

				<DialogContent dividers>
					<Paper
						sx={{
							p: 1,
							borderRadius: 0,
						}}
						elevation={0}
					>
						<DynamicFormWithoutSave
							showBackToList={false}
							DataToSet={DataToSet}
							dynamicMasterData={{}}
							showSaveBtn={offerJson.showSaveBtn}
							showTitle={false}
							screenTitle={""}
							showCancel={offerJson.showCancel}
							apiBaseURL={offerJson.apiBaseURL}
							showSaveNextBtn={offerJson.showSaveNextBtn}
							saveBtnText={"Search"}
							showSaveBtnMain={false}
							padding={true}
							paddingTop={true}
						/>

						{productDetails.length !== 0 &&
							(levelWiseType == "5" || levelWiseType == "7") && (
								<RTTable
									columns={this.columnsForLevelWise}
									tableData={productDetails}
									isActionColActive={false}
									showPegination={false}
								/>
							)}
						<br />
						{offerDetails.length !== 0 && (
							<RTTable
								columns={this.columns}
								tableData={offerDetails}
								isActionColActive={false}
								showPegination={false}
							/>
						)}
					</Paper>
				</DialogContent>
			</ClassicBootstrapDialog>
		);
	};

	renderEnhancedUI = () => {
		const { openPopUpFlag, headerData, isLoading } = this.state;

		return (
			<EnhancedBootstrapDialog
				onClose={this.handleClose}
				aria-labelledby="offer-details-dialog-title"
				open={openPopUpFlag}
				className="offer-details-dialog"
				classes={{ root: "offer-details-dialog" }}
				PaperProps={{
					className: "offer-details-scope",
				}}
				fullWidth
				maxWidth="md"
			>
				<EnhancedBootstrapDialogTitle
					id="offer-details-dialog-title"
					onClose={this.handleClose}
				>
					<Box className="offer-details-dialog-header">
						<Box className="offer-details-dialog-header-icon">
							<LocalOfferOutlinedIcon />
						</Box>
						<Box>
							<TypographyCompo className="offer-details-dialog-title">
								Offer Details
							</TypographyCompo>
							<TypographyCompo className="offer-details-dialog-subtitle">
								{!isLoading && headerData.name
									? `Viewing details for ${headerData.name}`
									: "Complete offer information at a glance"}
							</TypographyCompo>
						</Box>
					</Box>
				</EnhancedBootstrapDialogTitle>

				<DialogContent dividers>
					<Box className="offer-details-body">
						{this.renderEnhancedContent()}
					</Box>
				</DialogContent>
			</EnhancedBootstrapDialog>
		);
	};

	render() {
		const { showEnhancedOfferUI = false } = this.props;

		if (showEnhancedOfferUI) {
			return this.renderEnhancedUI();
		}

		return this.renderClassicUI();
	}
}

OfferDetailsOnBillingPreview.propTypes = {
	orderOfferId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
		.isRequired,
	onClose: PropTypes.func.isRequired,
	showEnhancedOfferUI: PropTypes.bool,
};

OfferDetailsOnBillingPreview.defaultProps = {
	showEnhancedOfferUI: false,
};

const mapStateToProps = (state) => ({
	productList: state.product,
});

const mapDispatchToProps = {
	showNotification,
	showLoador,
	getOfferHeaderById,
	getActiveProduct,
};

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(OfferDetailsOnBillingPreview);
